module.exports = __webpack_public_path__ + "static/Commune-Nuit_Debout_web-2eee4d1707a7e03656332901064165b9.eot";